import { createContext } from 'react';

const FrameContext = /*#__PURE__*/createContext(undefined);

export { FrameContext };
